<template>
  <small class="small-text" :class="{['is-'+variant]:variant}"><slot></slot></small>
</template>

<script>
export default {
  name: 'small-text',
  props: {
    variant: String
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.small-text {
  font-size: 12px;
  line-height: 1.4;
  color: #999;
  + .small-text{
    margin-top: 6px;
  }
  &.is-caution {
    color: $orange
  }
  a {
    cursor: pointer;
    color: #999;
    text-decoration: underline;
  }
}
</style>